import React, { useState, useEffect, useContext } from 'react';
import {useNavigate,useParams} from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { handleFaltas, handlePromedio } from '../../helpers/handlerFunctions';
import { CardDetalles } from '../cards/CardDetalles';
import { GlobalContext } from '../../context/GlobalContext';


export const Detalles = () => {

    const [loading, setLoading] = useState(true);
    const { materia } = useParams();
    const navigate = useNavigate();

    //GET GLOBAL CONTEXT
    const context = useContext(GlobalContext);
    const { Calificaciones, darkTheme } = context;

    const [data, setData] = useState([]);
    const [promedio, setPromedio] = useState(null);
    const [nombre, setNombre] = useState('');

    useEffect(() => {
        if (Calificaciones?.data) {
            const materias = Calificaciones.data.find(c => c.relationships.materiaRelacionada.data.id === materia);
            setNombre(getNombreMateria(materias));
            setData(materias);
            setPromedio(materias.attributes.promedio);
            setLoading(false);
        }
    }, [Calificaciones, materia]);

    const getNombreMateria = (data) => {
        const clave = data.relationships.materiaRelacionada.data.id;
        const included = Calificaciones.included.find(c => c.id == clave && c.type == "materias");
        return included.attributes.nombreMateria;
    }

    const handleClick = () => {
        navigate(-1);
    }

    const handleCalificadas = actividades => {
        try {
            const total = actividades.length;
            let calificadas = 0;
            actividades.forEach(actividad => {
                if (actividad.meta.calificacion != null)
                    calificadas++;
            });
            return `${calificadas}/${total}`;
        } catch (ex) {
            console.error(ex);
            return '0/0';
        }
    }

    return (
        <Container className={(darkTheme) ? "home__bg-white bg-dark-primary" : "home__bg-white"}>
            {
                (!loading) &&
                <>

                
                    <Row>
                        <Col>
                            <div className="margin-primary">
                                <span className={darkTheme ? "materia-desc text-dark" : "materia-desc"} onClick={handleClick} ><i className="bi bi-chevron-left"></i>{nombre}</span>
                                {(promedio != null) && <span className="detalle">Promedio: {promedio}</span>}
                                
                                <span className="detalle">Faltas: {handleFaltas(data.attributes.limiteFaltas, data.attributes.numeroFaltas)}</span>
                                <span className="detalle">Actividades calificadas: {handleCalificadas(data.relationships.actividadesDelCurso.data)}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {
                            data.relationships.actividadesDelCurso.data.map((item, i) => (
                                <CardDetalles key={item.id} data={item} darkTheme={darkTheme} />
                            ))
                        }
                    </Row>
                </>
            }
            
        </Container>
    )
}
